import { useContext } from 'react';
import FloatingInput from '../../../dustControl/components/FloatingInput';
import { FormModal } from '../../../dustControl/components/FormModal';
import { UserContext } from '../../service/userContext';
import BasicButton from '../../../dustControl/components/BasicButton';

const ViewPin = ({ setModalShow, setVisible }) => {
  const { userInfo } = useContext(UserContext);
  return (
    <FormModal header="Your PIN number">
      <FloatingInput
        disabled
        style={{ width: '100%' }}
        value={userInfo.pin_number}
        label="Current PIN"
        type="text"
      />
      <div className="d-flex gap-2 justify-content-end w-100 mt-3 text-center">
        <BasicButton onClick={() => setVisible(false)} outlined>
          Cancel
        </BasicButton>
        <BasicButton
          variant="outline-dark"
          onClick={() => setModalShow({ editPin: true })}
          outlined
        >
          Edit
        </BasicButton>
      </div>
    </FormModal>
  );
};

export default ViewPin;
